export default __webpack_public_path__ + "static/media/oriori-course.c9f56b9c.png";